import {FormControlLabelProps} from '@mui/material/FormControlLabel';
import React, {ChangeEvent} from 'react';
import Checkbox from 'components/inputs/Checkbox';
import {useController} from 'react-hook-form';
import {useMemoRef} from 'common/hooks/useMemoRef';
import {useRegisterLabel} from 'common/context/FormContext';

type CheckboxProps = {
   name: string;
   label?: React.ReactNode;
   className?: string;
   disabled?: boolean;
   labelPlacement?: FormControlLabelProps['labelPlacement'];
   autoFocus?: boolean;
   defaultChecked?: boolean;
   value?: any;
   inverse?: boolean;
   onChange?: (e: ChangeEvent<HTMLInputElement>) => void;
};

const HookFormCheckbox = ({name, value, onChange, ...restProps}: CheckboxProps) => {
   // const [field, meta, helpers] = useField({name, type: 'checkbox'});

   const methods = useController({
      name,
      // rules: {required: true},
      // defaultValue: '',
   });
   useRegisterLabel(name, restProps.label as string);

   // console.debug('HookFormCheckbox', methods);

   const {
      field: {onChange: fieldOnChange, onBlur, ref, value: checked},
      fieldState: {error: _error},
   } = methods;

   const error = !!_error;
   const _onChange = React.useCallback(
      (e: ChangeEvent<HTMLInputElement>) => {
         fieldOnChange(e);
         onChange && onChange(e);
         // TODO check touched behaviour
         // if (!meta.touched) {
         //    helpers.setTouched(true);
         // }
      },
      [fieldOnChange, onChange]
   );

   const val = value ?? true;
   const _ref = useMemoRef(ref);

   return (
      <Checkbox
         onChange={_onChange}
         error={error}
         value={val}
         checked={checked === val}
         onBlur={onBlur} // notify when input is touched/blur
         // value={value} // input value
         name={name} // send down the input name
         inputRef={_ref}
         {...restProps}
      />
   );
};

export default React.memo(HookFormCheckbox);
